'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-rich-text';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function RichText(_ref) {
  var content = _ref.content,
      className = _ref.className,
      headline = _ref.headline,
      style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(style), style))
  }, headline && /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }));
}
RichText.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  content: PropTypes.string.isRequired,

  /** */
  headline: PropTypes.string,

  /** */
  style: PropTypes.oneOf(['dark', 'light'])
};

module.exports = RichText;
